import { memo } from 'react';
import { Box, Skeleton, Text } from '@betty/moonlight';
import { MostSearchedProps } from './MostSearched.types';
import Games from '../../Games/Games';
import usePromotedContent from '../../../hooks/usePromotedContent';

function MostSearched(props: MostSearchedProps) {
  const { gameIds, isFetching } = usePromotedContent();

  if (isFetching) {
    return <Skeleton height={128} marginHorizontal="space-600" />;
  }

  if (!gameIds.length) {
    return null;
  }

  return (
    <Box {...props} gap="space-300">
      <Text
        variant="body-s-semi"
        locKey="mostSearched"
        locNS="games"
        color="darkSurfacePrimary"
        paddingHorizontal="space-600"
      />
      <Games ids={gameIds} imageType="square" paddingLeft="space-600" />
    </Box>
  );
}

export default memo(MostSearched);
